import { forwardRef } from 'react';
import clsx from 'clsx';

const Input = forwardRef(function Input({ label, error, helperText, className, id, ...props }, ref) {
  const inputId = id || props.name;

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-foreground-muted mb-1.5">
          {label}
        </label>
      )}
      <input
        ref={ref}
        id={inputId}
        aria-invalid={!!error}
        aria-describedby={error ? `${inputId}-error` : undefined}
        className={clsx(
          'w-full rounded-xl bg-background-elevated border px-3.5 py-2.5 text-sm text-foreground',
          'placeholder:text-foreground-subtle transition-colors',
          'focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent',
          error ? 'border-danger' : 'border-border focus:border-border-strong',
          className
        )}
        {...props}
      />
      {error && (
        <p id={`${inputId}-error`} className="mt-1.5 text-xs text-danger">
          {error}
        </p>
      )}
      {!error && helperText && <p className="mt-1.5 text-xs text-foreground-subtle">{helperText}</p>}
    </div>
  );
});

export default Input;
